import {createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
    primary: { main: '#0072BC' },
    secondary: { main: '#6f6f6f' },
  },
  typography: { useNextVariants: true },
});
